// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k3-3";
export var downloadButton = "_k3-4";
export var fileContainer = "_k3-9 _k3-7";
export var fileContainerBase = "_k3-7";
export var fileContainerFixedHeight = "_k3-8 _k3-7";
export var fileInfo = "_k3-5";
export var fileInfoWidthRestricted = "_k3-6";
export var fileType = "_k3-1";
export var fileTypeName = "_k3-2";
export var image = "_k3-0";
export var link = "_k3-b";
export var overflowEllipsis = "_k3-a";